import localScaleManager from "../../../helpers/LocalScaleManager";

export default class MessageBox {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   */
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;

    this.text = "";
    this.text = this.text.padStart(30, "a");
    this.textObj = this.scene.add.bitmapText(0, 0, "HelveticaNeue", this.text);
    this.textObj.setData("width", this.textObj.width);
    this.textObj.setData("height", this.textObj.height);
    this.table.poolArray.push(this.textObj);

    this.initX = 0;
    this.initY = 0;
    this.width = 0;
    this.height = 0;
  }

  /**
   * @param text {string}
   */
  updateText(text) {
    this.text = text;
    this.textObj.setText(text);
    this.textObj.setX(this.initX + (this.width - this.textObj.width * 1.1));
  }
  /**
   * @param width of table
   * @param height of table
   * @param initX of table
   * @param initY of table
   */
  positionControls(initX, initY, width, height) {
    this.initX = initX;
    this.initY = initY;
    this.width = width;
    this.height = height;
    this.textSize = width / 2;
    localScaleManager.scaleBitMapText(
      this.textObj,
      this.textSize,
      this.table.buttonManager.leftBtnObj.displayHeight,
      0,
      1,
      false
    );
    this.textObj.setPosition(
      initX + (width - this.textObj.width * 1.1),
      this.table.buttonManager.leftBtnObj.y
    );
    this.updateText("");
  }
  /**
   * @param width of table
   * @param height of table
   * @param initX of table
   * @param initY of table
   */
  reposition(initX, initY, width, height) {
    this.initX = initX;
    this.initY = initY;
    this.width = width;
    this.height = height;
    this.textSize = width / 2;
    this.textObj.setPosition(
      initX + (width - this.textObj.width * 1.1),
      this.table.buttonManager.leftBtnObj.y
    );
  }
  remove() {
    this.textObj.destroy();
  }
}
